<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("commons.edit") }} {{ apiUser.name }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-text-field
            v-model="apiUser.name"
            :rules="rules.name"
            :label="$t('commons.name')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            v-model="apiUser.useremail"
            :rules="rules.email"
            :label="$t('commons.email')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              @click="save"
              :disabled="!isEditable"
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { APIUserService } from "@/services"
import { isEqual } from "@/utils/object"
import { required, max64, email } from "@/utils/validator"

import _ from "lodash"

export default {
  name: "APIUserEditor",
  props: {
    hasUniqueName: {
      type: Function,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    apiUser: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    }
  },
  data() {
    return {
      rules: {
        description: [],
        email: [required, email, max64],
        name: [required, max64]
      },
      nameField: null
    }
  },
  created() {},
  methods: {
    getDefaultValue() {
      return {
        name: "",
        useremail: ""
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (data.id > 0) {
        return APIUserService.put(data)
      } else {
        return APIUserService.post(data)
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (isEqual(this.apiUser, this.value)) {
          // Objects are equal, no changes to perform
          this.$emit("success")
        } else {
          this.performSave(this.apiUser)
            .then(response => {
              this.$emit("input", response)
              this.$emit("success")
            })
            .catch(error => {
              const message = error?.response.data?.state
              this.$emit("error", message)
            })
        }
      }
    }
  }
}
</script>
